module.exports = __webpack_public_path__ + "static/montebello-eeec253df7da829cd505d0668ceb8d26.png";